import { css, DefaultTheme, ThemedCssFunction } from 'styled-components';

const desktopWidth = '769px';

const desktop: ThemedCssFunction<DefaultTheme> = (strings, ...interpolations) => css`
  @media (min-width: ${desktopWidth}) {
    ${css(strings, ...interpolations)}
  }
`;

export const media = {
  desktop,
};
